import {css} from '@emotion/css';
import {mq, Breakpoints} from '@fo/shared/styles/mixins';
import {coloursV2, fonts, spacing} from '@fo/shared/styles/variables';
import {colours} from '@fo/shared/styles/variables/coloursTide';

const styles = {
  footerV2: css`
    label: footerV2;
    background-color: ${coloursV2.background.tideBlue};
    color: ${colours.grey['00']};
  `,
  linksWrapper: css`
    label: footerV2__linksWrapper;
    display: flex;
    flex-direction: column;
    gap: ${spacing.TIDE_XS};
    border-bottom: 0.1rem solid ${colours.grey[400]};
    padding-bottom: ${spacing.XS};
    margin-bottom: ${spacing.XS};
    ${mq(Breakpoints.TABLET)} {
      display: grid;
      grid-template-columns: 1fr 1fr 4fr;
      gap: 2rem;
    }
  `,
  linkContainer: css`
    label: footerV2__linkContainer;
    display: flex;
    flex-direction: column;
    gap: ${spacing.TIDE_XS};

    a {
      text-decoration: none;
      color: ${colours.grey['00']};
      cursor: pointer;
      font-size: ${fonts.size.L};
    }
  `,
  linkHeader: css`
    label: footerV2__linkHeader;
    font-size: ${fonts.size.TIDE_H4_MOBILE};
    font-weight: ${fonts.weight.SEMI_BOLD};
    ${mq(Breakpoints.TABLET)} {
      font-size: ${fonts.size.M};
    }
  `,
  socialIconContainer: css`
    label: footerV2__socialIconContainer;
    display: flex;
    gap: ${spacing.XXXS};
  `,
  socialIcon: css`
    label: footerV2__socialIcon;
    width: 3.8rem;
    height: 3.8rem;
    ${mq(Breakpoints.TABLET)} {
      width: 2.4rem;
      height: 2.4rem;
    }
  `,
  logoDisclaimerContainer: css`
    label: footerV2__logoDisclaimerContainer;
    display: flex;
    flex-direction: column;
    gap: ${spacing.TIDE_XS};
    ${mq(Breakpoints.DESKTOP)} {
      display: grid;
      grid-template-columns: 1fr 5fr;
      gap: 2rem;
    }
  `,
  logo: css`
    label: footerV2__logo;
    width: 11rem;
  `,
  disclaimer: css`
    label: footerV2__disclaimer;
    font-size: 0.8rem;
    ${mq(Breakpoints.TABLET)} {
      font-size: ${fonts.size.S};
    }
  `,
};

export default styles;
